import * as React from "react"
import {useState} from "react"
import {StaticImage} from "gatsby-plugin-image";
import Menu from "../../components/menu";
import "../../styles/header.scss"
import {Link} from "gatsby";
import {AnchorLink} from "gatsby-plugin-anchor-links";


export default function Header() {
    const [expandMenu, setExpandMenu] = useState(false);

    return <div className='header'>
        <header>
            <nav className="navbar" role="navigation" aria-label="main navigation">
                <div className="navbar-brand">
                    <Link to="/">
                        <StaticImage
                            placeholder="blurred"
                            className='logo'
                            src='../../images/Logo.png'
                            alt='Huguette Bello - logo'/>
                    </Link>
                    <a role="button"
                       onClick={() => setExpandMenu(!expandMenu)}
                       className={`button is-danger navbar-burger${expandMenu ? ' is-active' : ''}`}
                       aria-label="menu"
                       aria-expanded="false">
                        <span aria-hidden="true"/>
                        <span aria-hidden="true"/>
                        <span aria-hidden="true"/>
                    </a>
                </div>
                <div className={`navbar-menu${expandMenu ? ' is-active' : ''}`}>
                    <div className="navbar-end">
                        <Menu/>
                        {/*<div className="navbar-item">*/}
                        {/*    <AnchorLink className="button is-danger has-shadow" to="/#nous-rejoindre" title="Our team">*/}
                        {/*        <i className="fas fa-users"/>&nbsp;&nbsp;Nous rejoindre*/}
                        {/*    </AnchorLink>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </nav>
        </header>
    </div>;
}
